import { render, staticRenderFns } from "./denglongheng.vue?vue&type=template&id=42936160&scoped=true&"
import script from "./denglongheng.vue?vue&type=script&lang=js&"
export * from "./denglongheng.vue?vue&type=script&lang=js&"
import style0 from "./denglongheng.vue?vue&type=style&index=0&id=42936160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42936160",
  null
  
)

export default component.exports